/**
 * Códigos de erro da API de preventiva → mensagem amigável
 */
export const PREVENTIVE_MAINTENANCE_ERROR_MESSAGES: Record<string, string> = {
	PreventiveMaintenanceVehicleIdRequired: "ID do veículo é obrigatório.",
	PreventiveMaintenanceDateOfLastRequired:
		"Data da última preventiva é obrigatória.",
	PreventiveMaintenanceDateOfNextRequired:
		"Data da próxima preventiva é obrigatória.",
	PreventiveMaintenanceDateInvalidFormat:
		"Data deve estar no formato dd/mm/yyyy.",
	PreventiveMaintenanceKilometersInvalid:
		"Quilometragem deve ser maior ou igual a 0.",
	PreventiveMaintenanceNextDateMustBeGreaterThanLastDate:
		"A data da próxima preventiva deve ser maior que a da última.",
};

/** Mapeia nomes em PascalCase da API (fieldsErrors) para camelCase do formulário. */
export const PREVENTIVE_FIELD_API_TO_FORM: Record<
	string,
	"dateOfLastPreventive" | "dateOfNextPreventive" | "kilometersOfLastPreventive"
> = {
	DateOfLastPreventive: "dateOfLastPreventive",
	DateOfNextPreventive: "dateOfNextPreventive",
	KilometersOfLastPreventive: "kilometersOfLastPreventive",
};

export function getPreventiveMaintenanceErrorMessage(
	errorCode: string
): string {
	return (
		PREVENTIVE_MAINTENANCE_ERROR_MESSAGES[errorCode] ||
		"Não foi possível salvar a preventiva. Tente novamente."
	);
}
